import { RootState } from "store";
import { createSelector } from "@reduxjs/toolkit";

export const selectEventLandingState = (state: RootState) => state.eventLanding;

export const selectShowRegisterDialog = createSelector(
  selectEventLandingState,
  (eventLandingState) => eventLandingState.showRegisterDialog,
);
